import React from "react";
import Home from "./pages/Home";
import TestStudents from './TestStudents'; // import it here
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<Home />} />

        <Route path="/test-students" element={<TestStudents />} />
      </Routes>
    </Router>
  );
}

export default App;
